import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "./scss/index.scss";
import React from "react";
export function RatingStars(_ref) {
  var rating = _ref.rating;
  return React.createElement("div", {
    className: "rating-stars",
    style: _defineProperty({}, "--rating", rating.toString())
  });
}